import {log} from 'handsontable/helpers'
import React, {MouseEventHandler, ReactNode, useEffect, useState} from 'react'
import {Modal, Row, Table, Button} from 'react-bootstrap'
import {formatDate} from '../helpers'
import {DEFAULT_META, DEFAULT_PAGE_OPTION} from '../constants/page-option/page-option'
import {IPageMeta} from '../interface/paging/meta-paging'
import TableData from './Table'
import {ColumnDef} from '@tanstack/react-table'
import {IPageOption} from '../interface/paging/paging'

type Props = {
  modalLogShow: boolean
  setModalLogShow: Function
  getLog: any
  logId: string
}

const ButtonComp: React.FC<Props> = ({modalLogShow, setModalLogShow, getLog, logId}) => {
  const [modalLogMoreShow, setModalLogMoreShow] = useState(false)
  const [logMore, setLogMore] = useState<string>('')
  const [meta, setMeta] = useState<IPageMeta>(DEFAULT_META)
  const [pageOption, setPageOption] = useState<IPageOption>(DEFAULT_PAGE_OPTION)
  const [columns, setColumns] = useState<ColumnDef<any>[]>([])
  const [log, setLog] = useState<any[]>([])

  useEffect(() => {
    const _columns: ColumnDef<any>[] = [
      {
        header: 'Modified Date',
        accessorFn: (row) => row?.updatedAt,
        id: 'updatedAt',
        cell: (info) => <>{formatDate(info.row.original.updatedAt)}</>,
      },
      {
        header: 'Modified By',
        accessorFn: (row) => row.updatedBy,
        id: 'updatedBy',
        cell: (info) => <>{info.row.original.updatedBy}</>,
      },
      {
        header: 'Log',
        accessorFn: (row) => row.log,
        id: 'log',
        cell: (info) => <div className='text-overflow'>{info.row.original.log}</div>,
      },
      {
        header: 'Action',
        id: 'action',
        cell: (info) => (
          <div className='d-flex justify-content-center'>
            <Button
              className='btn btn-icon btn-primary btn-sm me-1'
              onClick={() => onModalLogMore(info.row.original.log)}
            >
              <i className='fs-6 bi bi-eye-fill'></i>
            </Button>
          </div>
        ),
      },
    ]
    setColumns(_columns)
  }, [])
  useEffect(() => {
    if (modalLogShow) {
      onGetLog()
    }
  }, [pageOption.page, pageOption.sortBy, pageOption.order, pageOption.limit])
  useEffect(() => {
    if (modalLogShow) {
      setPageOption(DEFAULT_PAGE_OPTION)
      onGetLog()
    }
  }, [modalLogShow])
  const onModalLogMore = (log: string) => {
    setLogMore(log.replaceAll('\n', '<br />'))
    setModalLogMoreShow(true)
  }
  const onGetLog = async () => {
    const params = {
      ...pageOption,
      id: logId,
    }
    console.log('params', params)
    const service = new getLog()
    const _log = await service.request(params)
    console.log('_log', _log)
    setLog(_log.data)
    setMeta(_log.meta)
  }

  return (
    <>
      <Modal
        centered
        size='xl'
        show={modalLogShow}
        onHide={() => setModalLogShow(false)}
        backdrop='static'
      >
        <form noValidate className={modalLogMoreShow ? 'opacity-50' : ''}>
          <Modal.Header closeButton>
            <Modal.Title id='contained-modal-title-vcenter'>Log</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <TableData
                data={log || []}
                columns={columns}
                meta={meta}
                setMeta={setMeta}
                pageOption={pageOption}
                setPageOption={setPageOption}
              />
            </Row>
          </Modal.Body>
        </form>
      </Modal>
      {/* )} */}
      <Modal
        centered
        size='lg'
        show={modalLogMoreShow}
        onHide={() => setModalLogMoreShow(false)}
        backdrop='static'
      >
        <Modal.Header closeButton>
          <Modal.Title id='contained-modal-title-vcenter'>Log More</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <div dangerouslySetInnerHTML={{__html: logMore}} />
          </Row>
        </Modal.Body>
      </Modal>
    </>
  )
}
export default ButtonComp
